import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=640f8c69&"
import script from "./Trigger.vue?vue&type=script&lang=ts&"
export * from "./Trigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports